var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCommand)?_c('div',{staticClass:"linker",on:{"click":_vm.onCommand}},[_vm._t("default")],2):_c('router-link',_vm._b({},'router-link',_vm.linkerProps,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }